enum WeekDays {
  'Domingo',
  'Segunda-feira',
  'Terça-feira',
  'Quarta-feira',
  'Quinta-feira',
  'Sexta-feira',
  'Sábado',
}

enum MonthShort {
  'JAN',
  'FEV',
  'MAR',
  'ABR',
  'MAI',
  'JUN',
  'JUL',
  'AGO',
  'SET',
  'OUT',
  'NOV',
  'DEZ',
}

enum MonthFull {
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
}

export const getMonthShortText = (month: number) => {
  return MonthShort[month];
};

export const inputDateToDateObject = (date: string) => {
  const dateArray = date.split('-').map((field) => parseInt(field));
  const newDate = new Date(dateArray[0], dateArray[1] - 1, dateArray[2]);
  newDate.setHours(0, 0, 0, 0);

  return newDate;
};

export const getCurrentDateObject = () => {
  const date = new Date();
  date.setHours(0, 0, 0, 0);

  return date;
};

export const getInfosDateFormated = (startTime: Date, endTime: Date) => {
  const weekDay = WeekDays[startTime.getDay()];
  const startTimeFormated = startTime.toLocaleTimeString('pt-br', { hour: '2-digit', minute: '2-digit' });
  const endTimeFormated = endTime.toLocaleTimeString('pt-br', { hour: '2-digit', minute: '2-digit' });

  return `${weekDay}, das ${startTimeFormated} às ${endTimeFormated}`;
};

export const formatChatTimestamp = (createdAt: string) => {
  const messageDate = new Date(createdAt);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);

  // Reset hours for date comparison
  const messageDateOnly = new Date(messageDate.getFullYear(), messageDate.getMonth(), messageDate.getDate());
  const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
  const yesterdayOnly = new Date(yesterday.getFullYear(), yesterday.getMonth(), yesterday.getDate());

  const timeFormatted = messageDate.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });

  if (messageDateOnly.getTime() === todayOnly.getTime()) {
    return `hoje, ${timeFormatted}`;
  } else if (messageDateOnly.getTime() === yesterdayOnly.getTime()) {
    return `ontem, ${timeFormatted}`;
  } else {
    const day = messageDate.getDate();
    const month = MonthFull[messageDate.getMonth()];
    return `${day} de ${month}, ${timeFormatted}`;
  }
};

// Os módulos por escola guardam o horário de agendamento exatamente como chega; o
// legado é que movia a meia-noite enviada para as 09:00. Sem fuso: o servidor
// aplica o da escola.
export const toScheduledAt = (inputDate: string) => `${inputDate}T09:00:00`;
